import { types } from 'mobx-state-tree'

const TaskCustomerTiming = types.model('TaskCustomerTiming', {
  id: types.identifierNumber,
  time: types.string
})

export type ITaskCustomerTiming = typeof TaskCustomerTiming.Type
export default TaskCustomerTiming